import * as yup from 'yup';
import i18n from 'i18next';

export const schemaRemoveAgent = yup.object().shape({
  reason: yup.string().required(i18n.t`clientGigs.modal.remove.errors.reasonRequired`),
  terminationLetter: yup.string().required(i18n.t`clientGigs.modal.remove.errors.terminationLetterRequired`),
});

export const schemaSuspendAgent = yup.object().shape({
  reason: yup.string().required(i18n.t`clientGigs.modal.suspend.errors.reasonRequired`),
  suspensionLetter: yup.string().required(i18n.t`clientGigs.modal.suspend.errors.suspensionLetterRequired`),
});
